import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "", y = 36 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function Overline({ children, className = "" }) {
  return (
    <p className={`font-mono-lux text-[11px] uppercase tracking-[0.35em] text-amber-500 ${className}`}>
      {children}
    </p>
  );
}
